import { Component, OnInit } from '@angular/core';
import { ISiteSetting } from 'src/app/shared/interfaces/siteSetting';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent implements OnInit {

  about: ISiteSetting;


  constructor(public apiService: ApiService) {}


  ngOnInit(): void {
    this.getContent()
  }

  getContent() {
    this.apiService.apiCall('get', '/api/SiteInfo/AboutUs').subscribe((res: any) => {
      console.log(res);
      
      this.about = res.body.model;
    })
  }
  
}
